// Contentful
import contentfulClient from '../client/contentful';

// Components
import Footer from '../components/Footer/Footer';
import Navigation from '../components/Navigation/Navigation';
import PageWrapper from '../components/PageWrapper/PageWrapper';
import AboutHeader from '../components/AboutHeader/AboutHeader';
import StoriesBlock from '../components/StoriesBlock/StoriesBlock';
import InvestorsOverview from '../components/InvestorsOverview/InvestorsOverview';
import Benefits from '../components/Benefits/Benefits';
import SeoMeta from '../components/SeoMeta/SeoMeta';
import VacanciesBlock from '../components/VacanciesBlock/VacanciesBlock';

// Data Utils
import getSeoData from '../utils/data/getSeoData';
import getBenefitsData from '../utils/data/getBenefitsData';
import getStoriesBlockData from '../utils/data/getStoriesBlockData';
import getInvestorsOverviewData from '../utils/data/getInvestorsOverviewData';
import getVacanciesBlockData from '../utils/data/getVacanciesBlockData';
import getAboutHeaderData from '../utils/data/getAboutHeaderData';
import useOpenGraphImage from '../utils/useOpenGraphImage';

const Careers = (props) => {
  const data = props.data.fields;
  const aboutHeaderData = getAboutHeaderData(data);
  const investorsOverviewData = getInvestorsOverviewData(data);
  const benefitsData = getBenefitsData(data);
  const storiesBlockData = getStoriesBlockData(data);
  const vacanciesBlockData = getVacanciesBlockData(data);

  const { seoImageURL } = useOpenGraphImage('/home');
  const seoData = getSeoData(data, seoImageURL);

  return (
    <>
      <SeoMeta {...seoData} />
      <PageWrapper>
        <Navigation />
        {aboutHeaderData && <AboutHeader {...aboutHeaderData} />}
        {investorsOverviewData && <InvestorsOverview {...investorsOverviewData} />}
        {benefitsData && <Benefits {...benefitsData} />}
        {storiesBlockData && <StoriesBlock {...storiesBlockData} />}
        {vacanciesBlockData && <VacanciesBlock {...vacanciesBlockData} />}
      </PageWrapper>
      <Footer />
    </>
  );
};

export async function getStaticProps() {
  let data = {};

  const client = contentfulClient;

  await client.getEntry('29xT0CbsEgIl49tEFHHywK', { include: 10 }).then((entry) => {
    data = entry;
  });
  return {
    props: { data },
  };
}

export default Careers;
